<template>
    <div class="card">
        <div class="card-header">
            <h4>Ay Bazlı</h4>
        </div>
        <div class="card-block">
            <GChart type="ColumnChart" :data="ayBazliData" :options="options" />
        </div>
    </div>
    <div class="card">
        <div class="card-header">
            <h4>Malzeme Grubuna Göre</h4>
        </div>
        <div class="card-block">
            <GChart type="ComboChart" :data="malzemeGrubuData" :options="options" />
        </div>
    </div>
</template>

<script>

import { ref, onMounted } from "vue";
import { GChart } from 'vue-google-charts'

import Dashboard_KPI_Service from "@/_services.reports/dashboard_kpi.service";

export default
    {
        components: {
            GChart
        },
        setup() {
            const { depo_envanter, result } = Dashboard_KPI_Service();

            const ayBazliData = ref([]);
            const malzemeGrubuData = ref([]);

            onMounted(async () => {
                await depo_envanter();

                if (result.value.Success) {

                    ayBazliData.value = [['Ay', 'Tutar', { role: 'annotation' }]];
                    malzemeGrubuData.value = [['Malzeme Grubu', 'Tutar', { role: 'annotation' }, '']];

                    result.value.Data.Aylik.forEach((item) => {
                        ayBazliData.value.push([item.AY_TEXT, item.TOPLAM_TUTAR, item.TOPLAM_TUTAR]);
                    });

                    result.value.Data.MalzemeGrubuList.forEach((item) => {
                        malzemeGrubuData.value.push([item.MALZEME_GRUBU, item.TOPLAM_TUTAR, item.TOPLAM_TUTAR, item.ORAN_KUMULATIF]);
                    });

                    result.value.Success = false;
                }
            });

            const options = {
                width: "100%",
                legend: { position: 'none' },         // no legend
                backgroundColor: { strokeWidth: 1 },   // to get a nice box
                seriesType: "bars",                   // the standard chart type
                chartArea: { left: 75, top: 75, right: 60, bottom: 65, height: '100%', width: '100%' },
                // the second data column should be of type 'line' and should be associated with the second vertical axis
                series: { 1: { type: "line", targetAxisIndex: 1 } },
                height: 450
            }

            return { ayBazliData, malzemeGrubuData, options }

        }
    }

</script>